<template>
  <div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-body class="p-1">
        <div class="row">
          <div class="col-12 col-md-3">
            <b-form-group label="Trạng thái" class="font-weight-bolder mb-0">
              <v-select v-model="status" :options="dataOption" label="name" class="w-100" :reduce="val => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <!-- <b-form-group label="Người xử lý" class="author" label-for="author">
              <vue-simple-suggest v-model="author" ref="suggest" :list="onSearch" :max-suggestions="10" :min-length="3"
                display-attribute="full_name_alias" @select="onSuggestSelect" value-attribute="id" :debounce="100">
                <input placeholder="Nhập tên tài khoản" type="text" @keydown="onResearch($event)">
                <div slot="suggestion-item" slot-scope="scope">
                  <span v-html="boldenSuggestion(scope)"></span>
                </div>
              </vue-simple-suggest>
            </b-form-group> -->
            <b-form-group label="Người xử lý" class="font-weight-bolder mb-0 author">
              <v-select v-model="user_id" label="author" :filterable="false" :options="dataAuthor" :reduce="val => val.id"
                @search="onSearch">
                <template slot="no-options"> Nhập tên tài khoản </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center"> {{ option.full_name_alias }} </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center"> {{ option.full_name_alias }} </div>
                </template>
              </v-select>
            </b-form-group>
          </div>
          <b-col cols="4" class="mb-md-0 mb-2">
            <b-form-group label="Tìm kiếm" class="font-weight-bolder mb-0">
              <b-input-group>
                <b-form-input v-model="localSearchQuery" class="d-inline-block" placeholder="Tiêu đề"
                  @keyup.enter="fetchLog" />
                <b-input-group-append>
                  <b-button variant="primary" @click="updateSearchQuery">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </div>
      </b-card-body>
    </b-card>
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card no-body class="mb-0">
        <b-table ref="refUserListTable" class="articletype-relative" :items="itemsData" :fields="tableColumns"
          primary-key="id" :sort-by.sync="sortBy" responsive show-empty empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc">
          <template #cell(full_name)="data">
            <a href="javascript:void(0)" class="font-weight-bold d-block text-nowrap router-link-active"
              @click="dialog(data.item.article_id)">{{ data.item.full_name }}</a>
            <small class="text-muted">{{ data.item.username }}</small>
          </template>
          <!-- Column: Actions -->
          <template #cell(title)="data">
            <a href="javascript:void(0)" class="font-weight-bold text-wrap" @click="dialog(data.item.article_id)">{{
              data.item.title }}</a>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-modal id="modalState" size="lg" body-class="log" no-close-on-backdrop hide-footer title="Nhật ký tin bài">
        <article-view-log :article_id="article_id" />
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>

import {
  BOverlay, BCard, BRow, BCol, BButton, BTable, BPagination, BModal, BFormInput, BFormGroup,
  BCardHeader,
  BCardBody, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { ref, computed, watch } from '@vue/composition-api'
import { showToast } from '@/@core/utils/utils'
import store from '@/store';
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import ArticleViewLog from './ArticleViewLog.vue';
import vSelect from 'vue-select'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import _ from 'lodash';
import axios from '@axios';
export default {
  components: {
    BOverlay,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BCardBody,
    BPagination,
    BModal,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BCardHeader,
    ArticleViewLog,
    vSelect,
    VueSimpleSuggest
  },
  data() {
    return {
      article_id: '',
      dataAuthor: []
    }
  },
  setup() {
    const loading = ref(true)
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 30, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const localSearchQuery = ref('')
    const refListTable = ref(null)
    const itemsData = ref([]);
    const start_date = ref('');
    const end_date = ref('');
    const status = ref('')
    const user_id = ref('')
    const author = ref('')
    const tableColumns = [
      {
        key: 'id', sortable: false, label: 'ID', thAttr: { width: '5%' },
      },
      {
        key: 'full_name', sortable: false, label: 'Người xử lý', thAttr: { width: '12%' },
      },
      {
        key: 'created_at', sortable: false, label: 'Thời gian', thAttr: { width: '15%' },
      },
      {
        key: 'message', sortable: false, label: 'Trạng thái', thAttr: { width: '12%' },
      },
      { key: 'title', sortable: false, label: 'Tiêu đề bài viết' },
    ];
    const fetchAll = () => {
      loading.value = true
      store.dispatch('article/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        card_type: 'log',
        start_date: start_date.value,
        end_date: end_date.value,
        status: status.value,
        user_id: user_id.value
      })
        .then(response => {
          loading.value = false
          const result = response.data;
          if (result.code === 200) {
            itemsData.value = result.data.data
            total.value = result.data.total;
          }
        })
    }
    fetchAll();

    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([perPage, searchQuery, status, user_id], () => {
      currentPage.value = 1
      if (!loading.value) {
        refetchData()
      }

    })

    watch([currentPage], () => {
      if (!loading.value) {
        refetchData()
      }
    })

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
      if (start_date.value && end_date.value && start_date.value > end_date.value) {
        showToast('Ngày kết thúc phải lớn hơn ngày bắt đầu');
      } else {
        fetchAll();
      }
    }

    const refetchData = () => {
      fetchAll()
    }
    const config_date = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    const dataOption = [
      { id: 1, name: 'Đang biên tập' },
      { id: 2, name: 'Nhờ xử lý' },
      { id: 3, name: 'Chờ duyệt' },
      { id: 4, name: 'Chờ xuất bản' },
      { id: 5, name: 'Đã xuất bản' },
      { id: 6, name: 'Hủy xuất bản' },
      { id: 7, name: 'Đã xóa' },
      { id: 9, name: 'Lấy tin bài' },
      { id: 10, name: 'Trả lại' }
    ]

    const onSuggestSelect = (suggest) => {
      user_id.value = suggest.id
    }
    // const onSearch = (keyword) => {

    //   return store.dispatch('users/searchUser', {
    //     keyword: keyword
    //   }).then(response => {
    //     let result = response.data;
    //     if (result.code == 200) {
    //       dataAuthor.value = result.data;
    //     }
    //   })
    // }
    // const onResearch = (event) => {

    //   if (event.keyCode == 13) {
    //     user_id.value = ''
    //     //searchQuery.value = event.target.value
    //   }
    // }

    return {
      // Sidebar
      loading,
      perPage,
      currentPage,
      tableColumns,
      total,
      dataMeta,
      refListTable,
      perPageOptions,
      localSearchQuery,
      searchQuery,
      sortBy,
      isSortDirDesc,
      itemsData,
      config_date,
      start_date,
      end_date,
      updateSearchQuery,
      dataOption,
      status,
      user_id,
      author,
      onSuggestSelect,
      // onSearch,
      // onResearch,

    }
  },
  methods: {
    dialog(article_id) {
      this.article_id = article_id
      this.$bvModal.show('modalState');
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggest.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|\.]/gm).filter(t => !!t) || [''];
      return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
    },

    onSearch(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce((loading, search, vm) => {
      axios.get(`users/search?keyword=${search}`)
        .then((response) => {
          const result = response.data
          if (result.code == 200) {
            vm.dataAuthor = result.data
          }
          // const dataNews = vm.dataAuthor;
          // if (response.data.data.length > 0) {
          //   response.data.data.map((item) => {
          //     if (!vm.frmData.author.includes(item.id)) {
          //       dataNews.push(item);
          //     }
          //   })
          // }
          // const sortedObjs = _.sortBy(dataNews, 'full_name');

          loading(false);
        })
    }, 1000),
  },
}
</script>

<style lang="scss">
#modalState {
  .log {
    padding: 0 0 1rem 0;

    .group {
      .group-header {
        padding: 1rem;
        background: #f3f2f7
      }
    }
  }
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>